import React from 'react';
import { get, orderBy } from 'lodash';
import PropTypes from 'prop-types';
import { lassoForm, Text, TextArea, validator, Select } from '@bd/bdui-forms';
import { Redirect } from '@bd/bdcore-named-routes';
import { css, cx } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';

const styles = css`
  label {
    font-weight: 800;
    font-size: 18px;
    color: #686868;
    .required {
      color: #8F2329;
    }
  }
  .form-row {
    margin: 0 0 45px 0;
    @media(max-width: 767px) {
      flex-direction: column;
      min-height: 215px;
      margin: 0;
    }
    .col {
      padding: 0 30px 0 0;
      @media(max-width: 767px) {
        padding: 0;
      }
    }
  }
  input, select, textarea {
    border-radius: 0;
    border-color: #DCD7C7;
    padding: 25px 15px;
    @media(max-width: 767px) {
      padding: 15px;
    }
  }
  select.form-control:not([size]):not([multiple]) {
    height: 40px;
    @media(max-width: 767px) {
      height: 60px;
    }
  }
`;

function validate(values) {
  const response = {
    firstName: null,
    lastName: null,
    email: null,
  };

  if (!values.firstName) {
    response.firstName = {
      error: 'First Name is required',
    };
  }

  if (!values.lastName) {
    response.lastName = {
      error: 'Last Name is required',
    };
  }

  if (!values.email) {
    response.email = {
      error: 'Email is required',
    };
  } else if (!validator.isEmail(values.email)) {
    response.email = {
      error: 'Email must be valid',
    };
  }

  return response;
}

class ContactForm extends React.Component {
  constructor(props) {
    super(props);

    const { formApi } = props;

    formApi.setValue('formName', 'contactUs');

    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.success && !this.props.success) {
      this.props.onSuccess();
    }
  }

  render() {
    const { communities, className, formApi, success, noRedirect } = this.props;

    function getError(field) {
      return get(formApi, `touched.${field}`) && get(formApi, `errors.${field}`);
    }

    function getErrorClass(field) {
      if (get(formApi, `touched.${field}`) && get(formApi, `errors.${field}`)) {
        return 'ContactForm_invalid';
      }

      return null;
    }

    if (success) {
      if (noRedirect && typeof (window.ga) === 'function') {
        window.ga('send', 'event', 'Leads', 'Submit', 'Contact Us');
      }
      return (
        <div>
          {
            !noRedirect &&
            <Redirect
              name="contact-us-thank-you"
            />
          }
          {
            noRedirect &&
            <div style={{ color: '#00000' }}>
              <h4>Thank You</h4>
              <p>
                For contacting us. We have recieved your message and will respond as soon as {' '}
                possible.
              </p>
            </div>
          }
        </div>
      );
    }

    return (
      <div className={cx('pb-5', styles, className)}>
        <div className="form-row">
          <div className="col">
            <label htmlFor="firstName">First Name <span className="required">*</span></label>
            <Text
              field="firstName"
              name="firstName"
              className={`form-control ${getErrorClass('firstName')}`}
              placeholder="First Name *"
            />
            <div className="invalid-feedback">
              {getError('firstName')}
            </div>
          </div>
          <div className="col">
            <label htmlFor="lastName">Last Name <span className="required">*</span></label>
            <Text
              field="lastName"
              name="lastName"
              className={`form-control ${getErrorClass('lastName')}`}
              placeholder="Last Name *"
            />
            <div className="invalid-feedback">
              {getError('lastName')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="email">Email <span className="required">*</span></label>
            <Text
              field="email"
              name="email"
              className={`form-control ${getErrorClass('email')}`}
              placeholder="Email Address *"
            />
            <div className="invalid-feedback">
              {getError('email')}
            </div>
          </div>
          <div className="col">
            <label htmlFor="phone">Phone</label>
            <Text
              field="phone"
              name="phone"
              className={`form-control ${getErrorClass('phone')}`}
              placeholder="Phone"
            />
            <div className="invalid-feedback">
              {getError('phone')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="com">Community Of Interest?</label>
            <Select
              className={`form-control ${getErrorClass('com')}`}
              style={{ padding: '10px' }}
              name="com"
              field="com"
              placeholder="Make A Selection"
              options={orderBy(communities, 'name', 'asc').map(community => ({ label: get(community, 'name'), value: get(community, '_id') }))}
            />
            <div className="invalid-feedback">
              {getError('com')}
            </div>
          </div>
          <div className="col">
            <label htmlFor="priceRange">What Is Your Price Range?</label>
            <Select
              className={`form-control ${getErrorClass('priceRange')}`}
              style={{ padding: '10px' }}
              name="priceRange"
              field="priceRange"
              placeholder="Make A Selection"
              options={[
                { label: '$250,000-$350,000', value: '$250,000-$350,000' },
                { label: '$350,000-$450,000', value: '$350,000-$450,000' },
                { label: '$450,000-$550,000', value: '$450,000-$550,000' },
                { label: '$550,000-higher', value: '$550,000-higher' },
              ]}
            />
            <div className="invalid-feedback">
              {getError('priceRange')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label htmlFor="comments">Comments</label>
            <TextArea
              field="comments"
              name="comments"
              className={`form-control ${getErrorClass('comments')}`}
              placeholder="How can our Online Sales Advisors help you?"
              rows="4"
            />
            <div className="invalid-feedback">
              {getError('comments')}
            </div>
          </div>
        </div>
        <input type="hidden" name="domainAccountId" value="LAS-396770-01" />
        <input type="hidden" name="guid" value="" />
        <button type="submit" className="btn">Send</button>
      </div>
    );
  }
}

ContactForm.propTypes = {
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
  formApi: PropTypes.object.isRequired,
  success: PropTypes.bool,
  onSuccess: PropTypes.func,
  noRedirect: PropTypes.bool,
};

ContactForm.defaultProps = {
  className: undefined,
  success: undefined,
  onSuccess: () => {},
  noRedirect: false,
};

export default lassoForm({
  validate,
})(
  withData(
    {
      communities: true,
    },
  )(ContactForm),
);



// WEBPACK FOOTER //
// ./src/pages/ContactUs/ContactForm.js